import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";

import App from "./App";

//Inter
//note: the original google font import only requested these weights
//so even styles of font-black were rendering as 700
//to preserve this behavior only these weights are imported
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

// Jost: replaces futura
import "@fontsource-variable/jost";

// Nunito: replaces the unimported VAG Rounded
import "@fontsource-variable/nunito";

// Poppins
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/900.css";

// Material icons
import "@fontsource/material-icons-round";
import "@fontsource/material-icons-outlined";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { apolloClient } from "./apollo-client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { env } from "./env";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <ApolloProvider client={apolloClient}>
  //     <App />
  //   </ApolloProvider>
  // </React.StrictMode>
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (env.REACT_APP_PWA_ENABLED === "true") {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
